var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var uploadRequests = new Map();
function uploadProgressApi(data, url, onProgress, onError, onSuccess, onRemove) {
    if (url === void 0) { url = ""; }
    return __awaiter(this, void 0, void 0, function () {
        var xhr_1, uploadProgress_1, downloadProgress_1, isCancelled_1, abort_1, response, error_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    _a.trys.push([0, 2, , 3]);
                    xhr_1 = new XMLHttpRequest();
                    uploadRequests.set(data.filename, xhr_1);
                    uploadProgress_1 = 0;
                    downloadProgress_1 = 0;
                    isCancelled_1 = false;
                    abort_1 = function (filename) {
                        var _a;
                        if (!isCancelled_1) {
                            if (uploadRequests.has(filename)) {
                                isCancelled_1 = true;
                                (_a = uploadRequests.get(filename)) === null || _a === void 0 ? void 0 : _a.abort();
                                if (onRemove)
                                    onRemove(filename);
                            }
                        }
                    };
                    return [4 /*yield*/, new Promise(function (resolve, reject) {
                            xhr_1.upload.addEventListener("progress", function (event) {
                                if (event.lengthComputable) {
                                    uploadProgress_1 = (event.loaded / event.total) * 100;
                                    if (!isCancelled_1 && onProgress) {
                                        onProgress(data.filename, { upload: uploadProgress_1, download: downloadProgress_1 }, abort_1);
                                    }
                                }
                            });
                            xhr_1.addEventListener("error", function () {
                                if (isCancelled_1)
                                    return;
                                reject({
                                    success: false,
                                    uploadProgress: uploadProgress_1,
                                    error: "Request failed",
                                    status: 400,
                                    fileName: data === null || data === void 0 ? void 0 : data.filename,
                                });
                            });
                            xhr_1.onload = function () {
                                if (xhr_1.status >= 200 && xhr_1.status < 300) {
                                    var responseData = JSON.parse(xhr_1.responseText);
                                    if (!isCancelled_1 && onSuccess) {
                                        onSuccess(data === null || data === void 0 ? void 0 : data.filename, responseData);
                                    }
                                }
                                else {
                                    if (!isCancelled_1 && onError) {
                                        onError(data === null || data === void 0 ? void 0 : data.filename, uploadProgress_1.toFixed(0));
                                    }
                                }
                            };
                            // Error Handling
                            xhr_1.onerror = function () {
                                if (!isCancelled_1 && onError) {
                                    onError(data === null || data === void 0 ? void 0 : data.filename, uploadProgress_1.toFixed(0));
                                }
                            };
                            xhr_1.open("POST", url, true);
                            var token = localStorage.getItem("access_token");
                            xhr_1.setRequestHeader("Authorization", token);
                            xhr_1.setRequestHeader("Content-Type", "application/json");
                            xhr_1.send(JSON.stringify(data));
                        })];
                case 1:
                    response = _a.sent();
                    return [2 /*return*/, { response: response }];
                case 2:
                    error_1 = _a.sent();
                    return [2 /*return*/, {
                            response: {
                                uploadProgress: 0,
                                success: false,
                                error: error_1 || "An error occurred",
                                status: 400,
                                fileName: data === null || data === void 0 ? void 0 : data.filename,
                            },
                        }];
                case 3: return [2 /*return*/];
            }
        });
    });
}
export { uploadProgressApi };
